// URL Updater Controller
// 
// Purpose: Updates browser URL and page title when Turbo Streams are processed.
// 
// Why this exists:
// Firefox doesn't execute <script> tags inside Turbo Stream templates due to how
// it handles innerHTML-based DOM insertions. Chrome and Safari execute these scripts,
// but Firefox's HTML parser treats them differently for security reasons.
//
// This Stimulus controller provides a cross-browser solution by leveraging Stimulus's
// lifecycle hooks which execute reliably when DOM elements are inserted, regardless
// of the browser being used.
//
// Usage:
// Add a hidden div with this controller and the appropriate data attributes
// inside a Turbo Stream template to update the URL and title.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    path: String,
    title: String 
  }

  connect() {
    // Update browser URL if path value is provided
    if (this.hasPathValue && this.pathValue) {
      window.history.pushState({productFilterState: true}, null, this.pathValue)
    }
    
    // Update page title if title value is provided
    if (this.hasTitleValue && this.titleValue) {
      document.title = this.titleValue
    }
    
    // Remove this element from DOM after execution to keep DOM clean
    this.element.remove()
  }
}